import ImageWithTitle from 'containers/Slices/ImageWithTitle';
import ThreeColumnsImages from 'containers/Slices/ThreeColumnsImages';
import TextsOnly from 'containers/Slices/TextsOnly';
import TwoColumnsTab from 'containers/Slices/TwoColumnsTab';
import ImageWithTexts from 'containers/Slices/ImageWithTexts';
import RangesColumnsSeries from 'containers/Slices/RangesColumnsSeries';
import YoutubeVideoWithoutPlay from 'containers/Slices/YoutubeVideoWithoutPlay';
import ImageWithTwoColumns from 'containers/Slices/ImageWithTwoColumns';
import ImageWithBoldTitle from 'containers/Slices/ImageWithBoldTitle';

export const seriesOverviewTab = (block, type, index) => {
  switch (type) {
    case 'image_with_title':
      return <ImageWithTitle block={block} key={`${type}-${index}`} />;
    case 'three_columns_images':
      return <ThreeColumnsImages block={block} key={`${type}-${index}`} />;
    case 'youtube_video':
      return <YoutubeVideoWithoutPlay block={block} key={`${type}-${index}`} />;
    case 'texts_only':
      return <TextsOnly block={block} key={`${type}-${index}`} />;
    case 'two_columns_tab':
      return <TwoColumnsTab block={block} key={`${type}-${index}`} />;
    case 'image_with_texts':
      return <ImageWithTexts block={block} key={`${type}-${index}`} />;
    case 'ranges_columns':
      return <RangesColumnsSeries block={block} key={`${type}-${index}`} />;
    case 'image_with_two_columns':
      return <ImageWithTwoColumns block={block} key={`${type}-${index}`} />;
    case 'image_with_bold_title':
      return <ImageWithBoldTitle block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};
